import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import ModalBasic from "../../components/ModalBasic.jsx";
import LocationSelectorModal from "../../components/LocationSelectorModal.jsx";
import { setSelectedMerchant } from "@/store/app/action.js";
const LocationSelector = () => {
  const dispatch = useDispatch();
  const {
    locationSelectorOpened,
    merchants,
    selectedMerchant,
    selectedLocation,
  } = useSelector((state) => state.app);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  
  const setLocationSelectorOpened = (value) => {
    dispatch({ type: "SET_LOCATION_SELECTOR_OPENED", payload: value });
  };

  if (!selectedMerchant) return null;

  return (
    <>
      <ModalBasic
        id="basic-modal2"
        modalOpen={locationSelectorOpened}
        setModalOpen={setLocationSelectorOpened}
        width={"sm"}
        title="Select New Location"
      >
        {/* Modal content */}
        <div className="text-sm">
          <div className="space-y-2 mb-4">
            <div>
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="merchant"
              >
                Account
              </label>
              <select
                value={selectedMerchant.id}
                id="merchant"
                className="form-select"
                onChange={(e) => {
                  dispatch(setSelectedMerchant(e.target.value));
                }}
              >
                {merchants.map((merchant) => {
                  if (merchant.locations.length === 0) return null;
                  return (
                    <option value={merchant.id} key={merchant.id}>
                      {merchant.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          {selectedMerchant &&
            selectedMerchant.locations.length > 0 && (
              <div className="space-y-2">
                <div>
                  <label
                    className="block text-sm font-medium mb-1"
                    htmlFor="location"
                  >
                    Location
                  </label>
                  <button
                    onClick={() => setLocationModalOpen(true)}
                    className="form-select w-full text-left justify-between cursor-pointer"
                  >
                    <span>
                      {selectedLocation ? (selectedLocation.subname || selectedLocation.name) : "Select location..."}
                    </span>
                  </button>
                </div>
              </div>
            )}
        </div>
        {/* Modal footer */}
        <div className="px-5 py-4">
          <div className="flex flex-wrap justify-end space-x-2">
            <button
              className="btn-sm bg-indigo-500 hover:bg-indigo-600 text-white"
              onClick={(e) => {
                e.stopPropagation();
                setLocationSelectorOpened(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      </ModalBasic>

      <LocationSelectorModal
        modalOpen={locationModalOpen}
        setModalOpen={setLocationModalOpen}
        onLocationSelect={() => {
          // Optional callback when location is selected
        }}
      />
    </>
  );
};

export default LocationSelector;
